export const state = {
  routes: [],
  markers: [],
  sourceSelecting: false,
  destinationSelecting: false,
  isDeleteMode: false,
  source: undefined,
  destinations: [],
  selectedRoute: undefined,
  selectedMarker: undefined,
  mrpReport: undefined,
  endPointSelecting: false,
  endPoint: undefined,
  dispatchNotes: []
}

export const mutations = {
  CLEAR_SELECTION(state) {
    state.selectedRoute = []
    state.dispatchNotes = []
    for (let route of state.routes) {
      route.visible = true
    }
  },
  RESET(state) {
    state.routes = []
    state.markers = []
    state.sourceSelecting = false
    state.destinationSelecting = false
    state.isDeleteMode = false
    state.source = undefined
    state.destinations = []
    state.selectedRoute = undefined
    state.selectedMarker = undefined
    state.mrpReport = undefined,
    state.endPointSelecting = false,
    state.endPoint = undefined,
    state.dispatchNotes = []
  },
  SET_DATA(state, data) {
    state.routes = data.routes
    state.markers = data.markers
    state.mrpReport = data.mrpReport
  },
  SET_SOURCE_SELECTING(state, isSelecting) {
    state.sourceSelecting = isSelecting
    state.destinationSelecting = false
    state.endPointSelecting = false
  },
  SET_DESTINATION_SELECTING(state, isSelecting) {
    state.destinationSelecting = isSelecting
    state.sourceSelecting = false
    state.endPointSelecting = false
  },
  SET_IS_DELETE(state, isDelete) {
    state.isDeleteMode = isDelete
  },
  SET_SOURCE(state, source) {
    state.source = source
  },
  SET_ROUTE(state, data) {
    state.selectedRoute = data.route

    if (data.index) {
      state.routes[data.index].visible = true
  
      for (let i = 0; i < state.routes.length; i++) {
        if (i == data.index) {
          continue
        }
        state.routes[i].visible = false
      }
    }
  },
  ADD_DESTINATION(state, destination) {
    state.destinations.push(destination)
  },
  REMOVE_DESTINATION(state, destination) {
    state.destinations.splice(this.destinations.indexOf(destination), 1)
  },
  REMOVE_ROUTE(state, index) {
    state.routes.splice(index, 1)
    state.markers.splice(index + 1, 1)
  },
  MOVE_MARKER(state, moveObj) {
    let itemToUpdate = state.destinations.filter(
      x => x.latlng.lat == moveObj.old.lat && x.latlng.lng == moveObj.old.lng
    )[0]

    itemToUpdate.latlng.lat = moveObj.new.lat
    itemToUpdate.latlng.lng = moveObj.new.lng
  },
  CLEAR_DESTINATIONS(state) {
    state.destinations = []
  },
  SET_END_POINT_SELECTING(state, isSelecting) {
    state.endPointSelecting = isSelecting
    state.sourceSelecting = false
    state.destinationSelecting = false
  },
  SET_END_POINT(state, source) {
    state.endPoint = source
  },
  SET_DISPATCH_NOTES(state, data) {
    state.dispatchNotes = data
  }
}

export const actions = {
  setRoutes({ commit }, data) {
    commit('SET_DATA', data)
  },
  setSelectedRoute({ commit }, data) {
    commit('SET_ROUTE', data)
  },
  setSourceSelecting({ commit }, isSelecting) {
    commit('SET_SOURCE_SELECTING', isSelecting)
  },
  setDestinationSelecting({ commit }, isSelecting) {
    commit('SET_DESTINATION_SELECTING', isSelecting)
  },
  setIsDeleteMode({ commit }, isDelete) {
    commit('SET_IS_DELETE', isDelete)
  },
  setSource({ commit }, source) {
    commit('SET_SOURCE', source)
  },
  addDestination({ commit }, destination) {
    commit('ADD_DESTINATION', destination)
  },
  removeRoute({ commit }, routeIndex) {
    commit('REMOVE_ROUTE', routeIndex)
  },
  moveMarker({ commit }, moveObj) {
    commit('MOVE_MARKER', moveObj)
  },
  clearDestinations({ commit }) {
    commit('CLEAR_DESTINATIONS')
  },
  reset({ commit }) {
    commit('RESET')
  },
  clearSelection({ commit }) {
    commit('CLEAR_SELECTION')
  },
  setEndPointSelecting({ commit }, isSelecting) {
    commit('SET_END_POINT_SELECTING', isSelecting)
  },
  setEndPoint({ commit }, source) {
    commit('SET_END_POINT', source)
  },
  setDispatchNotes({ commit }, data) {
    commit('SET_DISPATCH_NOTES', data)
  }
}

export const namespaced = true
